<template>
    <tr class="item-summary" :class="documentStatus.class">
        <td>
            <div class="document">
                <div class="document-name">
                    <span>{{ documentName }}</span>

                    <a v-if="templateLink" :href="templateLink" target="_blank" class="btn">
                        <i class="fa fa-download"></i>
                        <span>Générer</span>
                    </a>
                </div>
            </div>
        </td>
        
        <td>
            <div class="state">
                <svg class="status-icon">
                    <use :xlink:href="documentStatus.iconHref"></use>
                </svg>

                <div class="document-status">
                    <span v-html="documentStatus.html"></span>
                </div>
            </div>
        </td>
        
        <td>
            <button class="btn btn-complete btn-sm" @click="toggleDetails">
                <i v-if="showDetails" class="fa fa-chevron-up"></i>
                <i v-else class="fa fa-chevron-down"></i>
                Gérer
            </button>
        </td>
    </tr>
</template>

<script type="text/babel">
export default {
    name:"DocumentItemSummary",
    
    props: {
        documentName: {
            type: String,
            required: true
        },
        documentStatus: {
            type: Object,
            required: true
        },
        templateLink: {
            type: String,
            default: null
        }
    },
    
    data () {
        return {
            showDetails: false
        }
    },

    methods: {
        toggleDetails() {
            this.showDetails = !this.showDetails
            this.$emit('toggle-details')
        }
    }
}
</script>

<style lang="scss" scoped>
    tr.item-summary {
        .document {
            .document-name {
                font-weight: 600;

                .btn {
                    font-size: 12px;
                    padding: 4px 12px;
                }

                > span {
                    margin-right: 5px;
                }
                > svg {
                    display: none;
                    width: 20px;
                    height: 20px;
                    fill: #777;
                    margin-right: 10px;

                    @media screen and (min-width: 768px) {
                        display: block;
                    }
                }
            }
        }
        .state {
            display: flex;
            align-items: center;
        }
        .status-icon {
            flex-shrink: 0;
            width: 25px;
            height: 25px;
            margin-right: 7px;
            fill: #717a7d;
        }

        td {
            vertical-align: middle;
            padding: 12px;
        }
        &.in-progress {
            > td {
                background-color: #e1ecef;
            }
        }
        &.expired {
            > td {
                background-color: #fae6e6;
            }
        }
        &.pending-validation {
            > td {
                background-color: #fcf8e3;
            }
        }
        &.validated {
            > td {
                background-color: #c6e4cd;
            }
            .status-icon {
                fill: #008f38;
            }
            .state {
                color: #008f38;
                font-weight: 600;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/CustomerDocuments/ItemSummary.vue